import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApplyVccData } from '../../model/match-vcc';
import { MatchingVccService } from '../../service/matching-vcc.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';

@Component({
    selector: 'app-confirmation-dialog-matching-vcc',
    templateUrl: './confirmation-dialog-matching-vcc.component.html',
    standalone: false
})
export class ConfirmationDialogMatchingVccComnponent {
  isLoadingSpinner = false;

  resolvedElements = 0;
  totalItemsToSave = 0;

  protected paymentDate: Date = new Date();

  get isOkButtonDisabled(): boolean {
    return this.isLoadingSpinner || this.totalItemsToSave === 0;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: { toSave: ApplyVccData[], noSave: ApplyVccData[] },
    @Optional() public confirmationDialogRef: MatDialogRef<ConfirmationDialogMatchingVccComnponent>,
    private _snackBar: MatSnackBar,
    private matchingVccService: MatchingVccService,
  ) {
    const uniqueTramsBookingNumbers = new Set<number>();
    const resolvedTramsBookingNumbers = new Set<number>();

    this.dialogData.toSave.forEach(element => {
      if (element.isEnabled && element.tramsBookingNo) {
        uniqueTramsBookingNumbers.add(element.tramsBookingNo);

        if (element.isEnabled && element.isResolved && !element.adjustedCommission) {
          resolvedTramsBookingNumbers.add(element.tramsBookingNo);
        }
      }
    });

    this.resolvedElements = resolvedTramsBookingNumbers.size;

    this.totalItemsToSave = uniqueTramsBookingNumbers.size;
  }

  okClick() {
    this.dialogData.toSave = this.dialogData.toSave.filter(element => element.isEnabled);
    if (this.totalItemsToSave === 0) {
      this.confirmationDialogRef.close(false);
      return;
    }

    this.isLoadingSpinner = true;
    if (this.dialogData && this.dialogData.toSave.length) {
      const paymentDate = moment(this.paymentDate).format('YYYY-MM-DD');
      this.matchingVccService.applyUpdate(this.dialogData?.toSave, paymentDate).subscribe({
        next: (result: Object) => {
          const success = result as boolean;
          if (success) {
            this._snackBar.open(
              'Request sent successfully to adjust suggested commission', 'Dismiss', {
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
            });
            this.confirmationDialogRef.close(true);
          } else {
            this._snackBar.open(
              'Failed to adjust suggested commission', 'Dismiss', {
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
            });
            this.confirmationDialogRef.close(true);
          }
        },
        error: () => {
          this._snackBar.open(
            'Error occurred while adjusting commission', 'Dismiss', {
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          });
          this.confirmationDialogRef.close(true);
        }
      });
    } else {
      this.confirmationDialogRef.close(true);
    }
  }

  onNoClick() {
    this.confirmationDialogRef.close(false);
  }
}
